import {MutationTree} from "vuex";
import {PoolsState} from "@/store/settings/pools/types";

export const mutations: MutationTree<PoolsState> = {
  setPools: (state, payload) => {
    state.pools = payload
  },
  pushPools:(state, payload) => {
    state.pools = state.pools.concat(payload)
  },
  setPoolItem: (state, payload) => {
    state.poolItem = payload
  },
  setPoolNumbers: (state, payload) => {
    state.poolNumbers = payload
  },
  setPoolNumberItem: (state, payload) => {
    state.poolNumberItem = payload
  }
}